import { BrandLogo } from '@components/ui';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';

const Navbar = (): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Box
      component="nav"
      sx={{
        position: 'sticky',
        top: 0,
        bgcolor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
        py: 1,
      }}
    >
      <BrandLogo
        height={32}
        onClick={() => navigate('/')}
        sx={{ ml: '30px' }}
      />
    </Box>
  );
};

export default Navbar;
